<template>
  <v-dialog v-model="showPopup" persistent max-width="520">
    <v-card class="pa-4">
      <v-card-title class="headline justify-center popup-title">
        Are you sure want to make the warehouse "{{item.name}}" inactive?
      </v-card-title>
      <v-card-text class="d-flex justify-center red--text">
        <p class="text-center">Attention! In this case, you will not have active warehouse.</p>
      </v-card-text>
      <v-card-actions class="text-xs-center justify-center">
        <v-btn
          @click="$emit('close')"
          depressed
          class="cancel-btn small-size"
        >
          Cancel
        </v-btn>
        <v-btn
          @click="$emit('makeInactive')"
          depressed
          class="save-btn small-size"
        >
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'makeInactiveWarehousePopup',
  props: {
    item: {
      type: Object,
      required: true
    },
    showPopup: {
      type: Boolean,
      required: true
    }
  }
}
</script>
